import { useParams } from "react-router-dom";
import { useTripContext } from "../TripContext";
import ParticipantsList from "./ParticipantsList";

const ParticipantsListWrapper = () => {
  const { variantguid } = useParams();
  const { tripData } = useTripContext();
  const activeStatuses = [3];
  const filteredParticipants = tripData?.registrations
    .filter((r) => activeStatuses.includes(r.status) && ( !variantguid || r.variantGuid === variantguid))
    .flatMap((r) =>
      r.participants.map((p) => ({
        ...p,
        reservationGuid: r.guid,
        variantGuid: r.variantGuid,
      }))
    )
    .filter((p) => p.status !== 4 && p.status !== 5)
    .sort((a, b) => a.preferredName.localeCompare(b.preferredName, "pl")) || [];

    const variant = tripData?.variants.find(v => v.guid === variantguid);
    const variantName = variant ? variant.name : null;


  return <ParticipantsList participants={filteredParticipants} tripName={tripData?.name} variantName={variantName} />;

};

export default ParticipantsListWrapper;
